import './WatchWristDemoTool.less';
import React, {useState, useEffect} from 'react';
import WatchWristViewer from "../../widgets/watch-wrist-viewer/WatchWristViewer";
import ProductStamp from "../../widgets/product-stamp/ProductStamp";
import WristSelector from "../../widgets/wrist-selector/WristSelector";
import AspectContainer from '../../../components/aspect-container/AspectContainer';
import ProductToolControlBlock from '../../widgets/product-tool-control-block/ProductToolControlBlock';
import __ from '../../../i18n';
import ProductBasicInfoTable from '../../widgets/product-basic-info-table/ProductBasicInfoTable';
import {
    REFERENCE_KEY_WATCH_LUG_WIDTH,
    REFERENCE_KEY_WATCH_LUGS_DISTANCE,
    REFERENCE_KEY_WATCH_CASE_DIAMETER,
    REFERENCE_KEY_WATCH_CASE_THICKNESS,
    REFERENCE_KEY_WATCH_CASE_MATERIAL,
    REFERENCE_KEY_WATCH_MOVEMENT_TYPE,
    REFERENCE_KEY_WATCH_CRYSTAL,
    REFERENCE_KEY_WATCH_WATER_RESISTANCE,
    REFERENCE_KEY_WATCH_FEATURES, REFERENCE_KEY_WATCH_GENDER,
} from '../../../model-constants/product-attribute-group/referenceKeys';
import ProductToolMessageBox from '../../widgets/product-tool-message-box/ProductToolMessageBox';
import ZoomController from "../../widgets/zoom-controller/ZoomController";


export default function WatchWristDemoTool({
    productCategory,
    attributes,
    attributeGroups,
    initialSelectedOption = null,
    onExposeSetSelectedOption,
    watchPrototypes,
    wristPrototypes,
    images,
    wristSizeMeasurementUrl,
}) {

    const [selectedOption, setSelectedOption] = useState(initialSelectedOption);

    useEffect(() => {
        onExposeSetSelectedOption(setSelectedOption);
    }, []);

    const [zoomScale, setZoomScale] = useState(1.05);

    const watchPrototype = watchPrototypes.find(t =>
        t.product_option_id === (selectedOption ? selectedOption.id : null)
    );

    if (!watchPrototype) {
        return <div className="watch-wrist-demo-tool">
            <div className="message-area">
                <ProductToolMessageBox>
                    {
                        selectedOption
                            ? <p>{__('There is no preview for option :option of this watch', {option: selectedOption.name})}</p>
                            : <p>{__('There is no preview for this watch')}</p>
                    }
                    <p>{__('Please choose another option to see preview')}</p>
                </ProductToolMessageBox>
            </div>
        </div>;
    }

    const genderedWristPrototypes = wristPrototypes.filter(t => t.gender === watchPrototype.appropriate_gender);

    if (genderedWristPrototypes.length === 0) {
        console.error('(WatchWristDemoTool) There are no gendered wrist prototypes to preview');
        return null;
    }

    const [selectedWristPrototype, setSelectedWristPrototype] = useState(genderedWristPrototypes[0]);

    return <div className="watch-wrist-demo-tool">
        <div className="viewer-wrapper">
            <WatchWristViewer
                watchPrototype={watchPrototype}
                wristPrototype={selectedWristPrototype}
                images={images}
                zoomScale={zoomScale}
            />
            <ZoomController
                defaultValue={zoomScale}
                onChange={setZoomScale}
                max={1.6}
            />
        </div>
        <div className="control-panel">
            <ProductStamp
                product={product}
                promotion={promotion}
                images={images}
            />
            <ProductToolControlBlock
                title={__('Select your wrist size')}
                extra={!wristSizeMeasurementUrl ? undefined :
                    <a href={wristSizeMeasurementUrl} target="_blank" title={__('Open in new tab')}>
                        {__('Wrist size measurement guidelines')}
                    </a>
                }
            >
                <WristSelector
                    wristPrototypes={genderedWristPrototypes}
                    defaultSelectedWristPrototypeId={selectedWristPrototype.id}
                    onSelectedWristPrototypeIdChange={(selectedId) => {
                        setSelectedWristPrototype(genderedWristPrototypes.find(t => t.id === selectedId));
                    }}
                />
            </ProductToolControlBlock>
            <ProductToolControlBlock
                title={__('Basic information')}
            >
                <ProductBasicInfoTable
                    productCategoryId={productCategory.id}
                    fixedAttributeIds={attributes.map(t => t.id)}
                    referenceKeys={[
                        REFERENCE_KEY_WATCH_FEATURES,
                        REFERENCE_KEY_WATCH_GENDER,
                        REFERENCE_KEY_WATCH_MOVEMENT_TYPE,
                        REFERENCE_KEY_WATCH_CRYSTAL,
                        REFERENCE_KEY_WATCH_WATER_RESISTANCE,
                        REFERENCE_KEY_WATCH_CASE_MATERIAL,
                        REFERENCE_KEY_WATCH_CASE_DIAMETER,
                        REFERENCE_KEY_WATCH_CASE_THICKNESS,
                        REFERENCE_KEY_WATCH_LUG_WIDTH,
                        REFERENCE_KEY_WATCH_LUGS_DISTANCE,
                    ]}
                />
            </ProductToolControlBlock>
        </div>
    </div>;
}
